import { Indicator } from '../../../Common/Charts/Indicator';
import { useAttentionChartsDataContext } from './hooks/useAttentionChartsDataContext';

export const PregnantWomen6OrMorePrenatalConsultations = () => {
    const { chartData } = useAttentionChartsDataContext();

    return (
        <Indicator
            title={'Indice de Gestantes com 6 ou mais Consultas Pré-Natal'}
            indicatorValue={chartData?.indicators?.pregnantWomen6OrMorePrenatalConsultations}
            className='aligned-container'
            goalValue={45}
            goalMessage='Meta Aceitável - acima de 45%'
        />
    );
};
